import { useEffect, useState } from "react";
import Select from "react-select";
import { optionSelector } from "../../../../config/apiSPA";
function AtmpToolBar({ year = "", onChange = () => {} }) {
  const [loadingYearState, setLoadingYearState] = useState(true);
  const [yearsOptionsState, setYearsOptionsState] = useState([]);

  const loadingData = async () => {
    setLoadingYearState(true);
    try {
      const yearOptions = await optionSelector(`/atmp-year-list`);
      setYearsOptionsState(yearOptions);
    } catch (error) {
    } finally {
      setLoadingYearState(false);
    }
  };
  const handleChangeYear = (val) => {
    onChange("year", val.value);
  };

  const selectedYears = yearsOptionsState.find((a) => a.value === year) ?? null;

  useEffect(() => {
    loadingData();
  }, []);
  return (
    <>
      <div className="mb-md-4 mb-3 d-md-flex">
        <Select
          isSearchable
          options={yearsOptionsState}
          value={selectedYears}
          onChange={handleChangeYear}
          styles={{
            menu: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
          classNamePrefix="react-select"
          placeholder={loadingYearState ? "Loading year..." : "Select year..."}
          noOptionsMessage={() => "Year list not found"}
        />
      </div>
    </>
  );
}

export default AtmpToolBar;
